module.exports = __webpack_public_path__ + "static/ecanta-black-friday-0351c5c606317ea6a712fbe570c2e7a3.png";